import {DeserializedRecord, Deserializer, deserializeSingleRelationship, JSONAPIRecord, JSONAPISingleRelationship} from "../Helpers";
import {deserializePhysician, Physician} from "../Physician";
import {deserializeItem} from "../index";

interface NotificationRecipient extends DeserializedRecord {
  physician: Physician;
}

interface NotificationRecipientData extends JSONAPIRecord {
  relationships: {
    physician: JSONAPISingleRelationship
  }
}

const deserializeNotificationRecipient: Deserializer<NotificationRecipient, NotificationRecipientData> = (data, included) => {
  const physician = deserializeSingleRelationship(data.relationships.physician, included, deserializePhysician);

  return {
    ...deserializeItem(data),
    physician
  };
};

export {NotificationRecipient, deserializeNotificationRecipient};
